export default __webpack_public_path__ + "static/media/work-2left-1.487d6149.png";